// extracted by mini-css-extract-plugin
export default {"container":"horizontal_container__mScyB","item":"horizontal_item__FfFyB"};